import {Component, OnInit} from '@angular/core';
import {NgbDateStruct, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ConfirmDialogComponent} from '../../dialog/confirm-dialog/confirm-dialog.component';
import {Discount} from '../../../classes/Discount';
import {DiscountService} from '../../../services/discount.service';
import {DiscountEditComponent} from '../discount-edit/discount-edit.component';

@Component({
  selector: 'app-discount-list',
  styleUrls: ['./discount-list.component.scss'],
  templateUrl: './discount-list.component.html',
})
export class DiscountListComponent implements OnInit {

  public discounts: Discount[];
  public errorMessage: string;
  private currentDialog = null;

  constructor(private discountService: DiscountService,
              private modalService: NgbModal,
              private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.refreshList();
  }

  refreshList(): void {

    this.discountService.getAll().subscribe({
      next: (discounts) => {
        this.discounts = discounts;
      },
      error: (error) => this.errorMessage = error.error.error
    });
  }

  openEditModal(discount: Discount): void {
    this.currentDialog = this.modalService.open(DiscountEditComponent,
      {
        scrollable: true,
        windowClass: 'modal-discount-edit',
        size: 'lg',
        centered: true,
      });

    this.currentDialog.componentInstance.discount = discount;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {

          const editedDiscount = new Discount(result.value);

          this.discountService.addOrEdit(editedDiscount).subscribe({
            next: () => this.refreshList(),
            error: (error) => {
              if (error.error && error.error.message) {
                this.errorMessage = error.error.message;
              } else {
                this.errorMessage = 'An unexpected error occurred';
              }
            }
          });
        }
      },
      (error) => { console.log('Dialog close error: ' + error); }
    );
  }

  openDeleteConfirmModal(discount: Discount): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent,
      {
        scrollable: true,
        windowClass: 'modal-discount-delete-confirm',
        size: 'md',
        centered: true,
      });

    this.currentDialog.componentInstance.message =
      'Are you sure that you want delete discount with id ' + discount.id + '?';

    this.currentDialog.result.then((result) => {
      if (result.status === 'confirmed') {
        this.discountService.delete(discount.id).subscribe({
          next: () => this.refreshList(),
          error: (error) => this.errorMessage = error.error.error
        });
      }
    }, (error) => {
      console.log('Dialog close error: ' + error);
    });
  }

}
